export default [
  {
      // 工单列表页
      path: '/auth',
      name: 'auth',
      meta: {
          group: 'auth'
      },
      component: () => import(/* webpackChunkName: "ticket" */ '../views/auth/index')
  },
  // {
  //     // 工单申请页
  //     path: '/ticket/add',
  //     name: 'ticketAdd',
  //     meta: {
  //         group: 'ticket'
  //     },
  //     component: () => import(/* webpackChunkName: "ticketAdd" */ '../views/ticket/add')
  // },
  // {
  //     //工单申请完成页面
  //     path: '/ticket/add/complete',
  //     name: 'ticketAddComplete',
  //     meta: {
  //         group: 'ticket'
  //     },
  //     component: () => import(/* webpackChunkName: "ticketAdd" */ '../views/ticket/add-complete')
  // },
  {
      // 工单详情页
      path: '/ticket/:ticket_id/detail',
      name: 'ticketDetail',
      meta: {
          group: 'ticket'
      },
      component: () => import(/* webpackChunkName: "ticketDetail" */ '../views/ticket/detail')
  },
  {
    // 创建工单
    path: '/create-ticket',
    name: 'createTicket',
    meta: {
      group: 'createTicket'
    },
    component: () => import(/* webpackChunkName: "CompanyCore" */ '../views/ticket/create')
  },
]
